import React from 'react';
import { withRouter } from 'react-router';
import _ from 'lodash';
import autoBind from 'react-autobind';
import DeclarationStore from '../stores/DeclarationStore.js';
import ApplicationStore from '../stores/ApplicationStore.js';
import ElectronicSubmissionStore from '../stores/ElectronicSubmissionStore.js';
import ContentService from '../services/ContentService.js';
import Transitions from '../core/Transitions.js';
import IDVerificationActions from '../actions/IDVerificationActions.js';
import ApplicationActions from '../actions/ApplicationActions.js';
import DeclarationActions from '../actions/DeclarationActions.js';
import Footer from './Footer.jsx';
import Spinner from './Common/Spinner.jsx';
import FooterUtil from './../utils/FooterHelper';
import NavigationBar from './NavigationBar.jsx';
import RouteConstants from '../constants/RouteConstants.js';
import { SpinnerSizes } from '../constants/ApplicationConstants';
import UserNotification from './Common/UserNotification.jsx';
import { Eligibility } from '../constants/IDVerificationConstants';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import ApplicationHelper from '../utils/ApplicationHelper.js';
import OmnitureTracking from '../utils/OmnitureTracking.js';

var isUserNotificationClosed = true;

function getStateFromStore() {
    return {
        product: DeclarationStore.getProduct(),
        eligibility: DeclarationStore.getEligibility(),
        content: ContentService.getContent().declaration,
        footerContent: ContentService.getContent().footer,
        moreMenuContent: ContentService.getContent().moreMenu,
        downloadMenuContent:ContentService.getContent().downloadMenu,
        entitlementAccessNotificationContent:ContentService.getContent().entitlementAccessNotification,
        showMoreMenu: DeclarationStore.getShowHideMore(),
        enableAgree: false,
        hideSpinner: DeclarationStore.isSpinnerHidden(),
        canAgreeDeclaration: DeclarationStore.canAgreeDeclaration(),
        disableButton: false,
        isUserNotificationClosed: isUserNotificationClosed,
        isEmulation: ApplicationStore.isEmulation(),
        formModel: DeclarationStore.getFormModel(),
        consolidatedFormModel: DeclarationStore.getConsolidatedFormModel(),
        accountNumber: DeclarationStore.getAccountNumber(),
        hasSubmitFailed: DeclarationStore.getHasSubmitFailed(),
        clientIdentificationMode: ApplicationStore.getClientIdentificationMode(),
        showDownloadMenu: DeclarationStore.getShowDownloadMenu(),
        formsToDownload: DeclarationStore.getFormsToDownload(),
        enableDownloadButton: DeclarationStore.getEnableDownloadButton(),
        accountType: DeclarationStore.getAccountType(),
        downloadInProgress: DeclarationStore.getDownloadInProgress(),
        selectedForms: DeclarationStore.getSelectedForms(),
        readyForDownload: DeclarationStore.getReadyForDownload(),
        downloadedForms: DeclarationStore.getDownloadedForms(),
        formDownloaded:DeclarationStore.getIsFormsDownloaded(),
        downloadFormsFailed: DeclarationStore.getDownloadFormsFailed(),
        applicationSubmitting: DeclarationStore.getApplicationSubmitting(),
        digitalConsentCheckEnabled: DeclarationStore.getDigitalConsentCheckEnabled(),
        waitingForDigitalConsentKillSwitch: DeclarationStore.getWaitingForDigitalConsentKillSwitch(),
        mobileNumbers: ElectronicSubmissionStore.getMobileNumbers(),
        applicationId: ElectronicSubmissionStore.getApplicationId()
    };
}

class Declaration extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getStateFromStore();
    }

    disableAgree() {
        if (!this.state.hideSpinner) {
            DeclarationActions.toggleHiddenSpinner(false);
        }
        this.setState({
            enableAgree: false
        });
    }

    enableAgree() {
        DeclarationActions.toggleHiddenSpinner(true);
        this.setState({
            enableAgree: true
        });
    }

    componentDidMount() {
        this.loadTimeout = setTimeout(this.enableAgree, 12000);
        DeclarationStore.addChangeListener(this._onChange);
        OmnitureTracking.getTrackingEnabled();
    }

    componentWillUnmount() {
        DeclarationStore.removeChangeListener(this._onChange);
        this.loadTimeout && clearTimeout(this.loadTimeout);
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.state.hideSpinner && this.state.enableAgree) {
            DeclarationActions.toggleHiddenSpinner(false);
            this.setState({
                disableButton: true
            });
        }

        if (nextState.formModel.hasDigitalSignature && nextState.formModel.DigitalSignatureTimeStamp) {
            IDVerificationActions.sendDigitalConsent(nextState.formModel.hasDigitalSignature, nextState.formModel.DigitalSignatureTimeStamp);
        }

        if ((!_.isEqual(this.state.eligibility, nextState.eligibility) && !nextState.eligibility.checkComplete)) {
            this.enableAgree();
            if (nextState.eligibility.eligible === Eligibility.Eligible) {
                IDVerificationActions.navigateToNetCodeEntryPage(this.state.product.value, this.state.mobileNumbers, this.state.applicationId);
                Transitions.forwardFromDeclaration(this.props.router, { valid: true }); 
            }
            else if (!this.state.accountNumber) {
                const applicationForSubmit = ApplicationHelper.getApplicationWithoutPredictiveSearchAdviceFee(nextState.formModel);
                ApplicationActions.submitApplication(nextState.product.value, applicationForSubmit, nextState.consolidatedFormModel.form.investmentAllocation.investmentOptions);
            }
        }

        if (!this.state.hasSubmitFailed && nextState.hasSubmitFailed){
            DeclarationActions.toggleHiddenSpinner(true);
            this.setState({
                disableButton: false
            });
        }
        else if (!this.state.accountNumber && nextState.accountNumber){
             Transitions.forwardFromDeclaration(this.props.router, { isShellAccount: nextState.formModel && nextState.formModel.isApplicationDataNotReadyForFunding });
        }
    }
    _onChange() {
        this.setState(getStateFromStore());
    }
    disagree() {
        IDVerificationActions.declarationDisagreed();
        window.scrollTo(0, 0);
        this.toggleNotification(false);

    }
    agree() {
        if (this.state.formModel && this.state.formModel.isApplicationDataNotReadyForFunding) {
            if (!this.state.accountNumber) {
                const applicationForSubmit = ApplicationHelper.getApplicationWithoutPredictiveSearchAdviceFee(this.state.formModel);
                ApplicationActions.submitApplication(this.state.product.value, applicationForSubmit, this.state.consolidatedFormModel.form.investmentAllocation.investmentOptions);
            }
        } else if (!this.state.accountNumber){
            this.disableAgree();
            DeclarationActions.toggleEligibilityCheckComplete();
        }
    }

    returnFormattedContent(content) {
        let copy = [];

        if (!content) {
            return null;
        }
        copy.push(<div key="DeclarationTopText" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t6 }} />);
        if (content.h1) {
            copy.push(<h2 key="productDeclarationHeader1">{content.h1}</h2>);
            copy.push(<div key="productDeclaration1" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t1 }} />);
        }

        copy.push(<h2 key="productDeclarationHeader2">{content.h2}</h2>);
        copy.push(<div key="productDeclaration2" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t2 }} />);
        copy.push(<h2 key="productDeclarationHeader3">{content.h3}</h2>);
        copy.push(<div key="productDeclaration3" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t3 }} />);

        if (content.h7) {
            copy.push(<h2 key="productDeclarationHeader7">{content.h7}</h2>);
            copy.push(<div key="productDeclaration7" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t8 }} />);
        }

        copy.push(<h2 key="productDeclarationHeader4">{content.h4}</h2>);
        copy.push(<div key="productDeclaration4" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t4 }} />);
		copy.push(<h2 key="productDeclarationHeader6">{content.h6}</h2>);
        copy.push(<div key="productDeclaration6" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t7 }} />);
        copy.push(<h2 key="productDeclarationHeader5" dangerouslySetInnerHTML={{ __html: content.h5 }}></h2>);
        copy.push(<div key="productDeclaration5" className="declaration__content" dangerouslySetInnerHTML={{ __html: content.t5 }} />);

        return copy;
    }
    toggleNotification(status) {
        isUserNotificationClosed = status;
        this.setState({
            isUserNotificationClosed: status
        });
    }

    checkIfActionAllowed() {
        if (this.state.hideSpinner)
        {
            this.agree();
        }

    }

    render() {
        const footerContent = FooterUtil.getContent(this.state.product.value, this.state.footerContent);
        const dockFooterStyle = FooterUtil.adjustViewport();
        const productCopy = this.state.content[this.state.product.value];
        const content = this.returnFormattedContent(productCopy);
        const hideSpinner = this.state.hideSpinner;
        const customInline = this.state.hideSpinner ? false : true;
        const spinner = <Spinner inline={customInline} hide={hideSpinner && !this.state.applicationSubmitting} size={SpinnerSizes.One} />;
        const downloadData = DownloadFormsHelper.createDownloadData(this.state);

        return (
            <div className="declaration">
                <div className="mainContent" style={dockFooterStyle}>
                    <NavigationBar
                        product={this.state.product}
                        route={RouteConstants.Declaration}
                        moreMenuContent={this.state.moreMenuContent}
                        showMoreMenu={this.state.showMoreMenu}
                        application={this.state.formModel}
                        clientIdentificationMode={this.state.clientIdentificationMode}
                        showDownloadMenu={this.state.showDownloadMenu}
                        accountType={this.state.accountType}
                        download={downloadData}/>
                    <UserNotification id="userNotificationForDeclarationEntitlement"
                        message={this.state.entitlementAccessNotificationContent}
                        onClick={() => this.toggleNotification(true)}
                        hideIcon={true}
                        wrapCopy={true}
                        isHidden={this.state.canAgreeDeclaration} />
                    <UserNotification id="userNotificationForDisagree" message={productCopy.disagreeHelpText}
                        hideIcon={true}
                        isHidden={this.state.isUserNotificationClosed} />
                    <nav className="navbar-sub-sectionName navbar navbar-sub">
                        <div className="container">
                            <div className="pull-left">
                                <span className="heading-text">{this.state.content.pageTitle}</span>
                                 </div>
                        </div>
                    </nav>
                    <div className="container declaration__mainContent">
                        {content}
                    </div>
                    <div className="navbar navigationBar">
                        <button type="button" disabled={!this.state.canAgreeDeclaration || this.state.isEmulation} className="btn btn-default btn-large navigationBar__disagreeBtn" onClick={this.disagree}>Disagree</button>
                        <button type="button" disabled={!this.state.canAgreeDeclaration || this.state.isEmulation || this.state.disableButton || this.state.applicationSubmitting} className="btn btn-large btn-success navigationBar__agreeBtn" onClick={this.checkIfActionAllowed}>{spinner}Agree</button>
                    </div>
                </div>
                <Footer content={footerContent} />
            </div>);
    }
}
export default withRouter(Declaration)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Declaration.jsx